import axios from "axios";

export default axios.create({
  // baseURL: "http://54.255.71.3/",
  // baseURL: "https://kc.arclabsdev.com/",
  baseURL: "https://api.kc-app.com/",
  headers: {
    "Content-Type": "application/json",
  },
});